module.exports = __webpack_public_path__ + "assets/img/index-partner11.4d35db16.jpg";